(() => {
  document.querySelectorAll('[data-reviews]').forEach((root) => {
    const list = root.querySelector('[data-review-list]');
    const rows = [...root.querySelectorAll('[data-review]')];
    const search = root.querySelector('[data-review-search]');
    const sortSelect = root.querySelector('[data-review-sort]');
    const countEl = root.querySelector('[data-review-count]');
    const empty = root.querySelector('[data-review-empty]');
    const more = root.querySelector('[data-review-more]');
    const pageSize = Number(root.dataset.pageSize) || 5;
    const filters = {
      rating: root.querySelector('[data-review-filter="rating"]'),
      media: root.querySelector('[data-review-filter="media"]'),
      colour: root.querySelector('[data-review-filter="colour"]'),
      size: root.querySelector('[data-review-filter="size"]'),
    };
    let visibleLimit = pageSize;

    function matches(row) {
      const term = (search?.value || '').trim().toLowerCase();
      if (term && !row.dataset.text.includes(term)) return false;
      if (filters.rating?.value && row.dataset.rating !== filters.rating.value) return false;
      if (filters.media?.checked && row.dataset.media !== '1') return false;
      if (filters.colour?.value && row.dataset.colour !== filters.colour.value) return false;
      if (filters.size?.value && row.dataset.size !== filters.size.value) return false;
      return true;
    }

    function sorted(items) {
      const mode = sortSelect?.value || 'featured';
      const byIndex = (a, b) => a.dataset.index - b.dataset.index;
      // Featured: photo reviews, then written reviews, then star-only reviews
      const weight = (row) => Number(row.dataset.media) * 2 + Number(row.dataset.hasText);
      return items.sort((a, b) => {
        if (mode === 'highest') return (b.dataset.rating - a.dataset.rating) || byIndex(a, b);
        if (mode === 'lowest') return (a.dataset.rating - b.dataset.rating) || byIndex(a, b);
        if (mode === 'media') return (b.dataset.media - a.dataset.media) || byIndex(a, b);
        return (weight(b) - weight(a)) || byIndex(a, b);
      });
    }

    function render() {
      const ordered = sorted([...rows]);
      ordered.forEach((row) => list.appendChild(row));
      const matching = ordered.filter(matches);
      ordered.forEach((row) => { row.hidden = true; });
      matching.slice(0, visibleLimit).forEach((row) => { row.hidden = false; });

      const shown = Math.min(visibleLimit, matching.length);
      if (countEl) {
        countEl.textContent = matching.length
          ? `Showing ${shown} of ${matching.length} ${matching.length === 1 ? 'review' : 'reviews'}`
          : '';
      }
      if (empty) empty.hidden = matching.length > 0;
      if (more) more.hidden = matching.length <= visibleLimit;
    }

    function reset() {
      visibleLimit = pageSize;
      render();
    }

    search?.addEventListener('input', reset);
    sortSelect?.addEventListener('change', reset);
    Object.values(filters).forEach((el) => el?.addEventListener('change', reset));

    more?.addEventListener('click', () => {
      visibleLimit += pageSize;
      render();
    });

    root.querySelector('[data-review-clear]')?.addEventListener('click', () => {
      if (search) search.value = '';
      if (filters.rating) filters.rating.value = '';
      if (filters.media) filters.media.checked = false;
      if (filters.colour) filters.colour.value = '';
      if (filters.size) filters.size.value = '';
      reset();
    });

    // Clicking a bar in the rating breakdown filters by that star rating
    root.querySelectorAll('[data-review-star]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!filters.rating) return;
        filters.rating.value = filters.rating.value === btn.dataset.reviewStar ? '' : btn.dataset.reviewStar;
        reset();
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    render();
  });
})();
